import { render, staticRenderFns } from "./learner-proficiency-chart.vue?vue&type=template&id=fd126404&"
import script from "./learner-proficiency-chart.ts?vue&type=script&lang=ts&"
export * from "./learner-proficiency-chart.ts?vue&type=script&lang=ts&"
import style0 from "./learner-proficiency-chart.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports